/**
 * Keeps a page to the roles it is for, inside an organisation (7 Oct 2026). The sidebar
 * already hides these pages from a Learner, but typing the address still opened them —
 * the course wizard ran to the end before the database refused the save.
 *
 *   creator — Courses, Templates, New course: anyone but a Learner-only member.
 *   manager — the Manage pages: Owner and Admins.
 *
 * Not the editor or Translate: a Learner can be invited to review a course, which opens
 * the editor. Outside organisations (status 'off' — all of production) it does nothing.
 */
import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useOrgs } from '@/lib/useOrgs'

/** `otherwise`: what someone without the role sees at this address instead of being sent Home —
 *  a Learner's Courses page is their My learning (12 Oct 2026). */
export function RoleGate({ need, children, otherwise }: { need: 'creator' | 'manager'; children: ReactNode; otherwise?: ReactNode }) {
  const o = useOrgs()
  if (o.status === 'off' || (!o.current && o.status !== 'loading')) return <>{children}</>
  if (!o.current) return null   // still finding out
  const ok = need === 'creator' ? !o.isLearnerOnly : o.isManager
  return ok ? <>{children}</> : otherwise ? <>{otherwise}</> : <Navigate to="/" replace />
}
